<template>
    <div>
        <div class="py-32">
            <div class="flex items-center justify-center">
                <div class="bg-white rounded-xl  justify-between p-32 py-20 mx-2">
                    <div class="flex flex-col items-center md:w-auto">
                        <h2 class="login__title ">
                            We encountered an issue. Please login again
                        </h2>
                        <button class="common-btn" @click="onLogout" :disabled="isLoadingLocal">LOGOUT</button>

                        <div class="common-error-message mt-2" v-if="errorLocal">{{errorLocal}}</div>
                    </div>
                </div>

            </div>
        </div>


    </div>
</template>

<script>
    import {ref} from 'vue'
    import {SecurityService} from "../Services"
    import {useAuth} from '@okta/okta-vue'

    export default {
        name: 'SSOError',
        setup() {
            const auth = useAuth();
            const errorLocal = ref(null);
            const isLoadingLocal = ref(false);

            const onLogout = async () => {
                isLoadingLocal.value = true;
                SecurityService.logout();
                try {
                    await auth.signOut();
                } catch (e) {
                    errorLocal.value = 'Unable to sign out of JA I.D. Please try again.';
                    isLoadingLocal.value = false;
                }
            };

            return {
                errorLocal,
                isLoadingLocal,
                onLogout,
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "../Styles/login.styl";
</style>
